export default __webpack_public_path__ + "static/media/logo-wunsch-mini.a47cc94b.svg";